// extracted by mini-css-extract-plugin
export default {"sidebar-layout":"SidebarLayout_sidebar-layout__klvH2","main":"SidebarLayout_main__t49Bq"};